import { Couple } from '@fs/zion-person'
import { Paragraph } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function CoupleHeaderSkeleton(): JSX.Element {
  const [t] = useTranslation()
  return (
    <>
      <Paragraph>{t('change-log.couple.label')}</Paragraph>
      <Couple noBoldName spouse1Obj={{}} spouse2Obj={{}} loading />
    </>
  )
}
